import { useEffect, useRef, useState } from 'react';

export function useNearViewport<T extends Element>(rootMargin = '600px 0px') {
  const elementRef = useRef<T>(null);
  const [isNearViewport, setIsNearViewport] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || isNearViewport) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setIsNearViewport(true);
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry?.isIntersecting) return;

      setIsNearViewport(true);
      observer.disconnect();
    }, { rootMargin });

    observer.observe(element);
    return () => observer.disconnect();
  }, [isNearViewport, rootMargin]);

  return { elementRef, isNearViewport };
}
